import { render, staticRenderFns } from "./posDayliReportTable.vue?vue&type=template&id=71c6dd31&"
import script from "./posDayliReportTable.vue?vue&type=script&lang=js&"
export * from "./posDayliReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports